<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { RouteNames } from '@/data/routes';
import { useRouter } from 'vue-router';
import { useProfiling } from '@/composables/useProfiling';
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';

import UserInviteModal from '@/pages/users/components/UserInviteModal.vue';
import UserNewOwnerForm from '@/pages/users/components/UserNewOwnerForm.vue';
import ErrorForm from '@/components/forms/ErrorForm.vue';

const router = useRouter();
const store = useStore();
const profiling = useProfiling(RouteNames.OWNERS.NEW, {
  type: store.getters.eventTypeBasedOnLoginsCount,
});

const errorMessage = ref(null);
const isInviteModalVisible = ref(false);

const allUsers = computed(() => {
  return store.getters.allUsers;
});

function handleError(error) {
  errorMessage.value = error;
}

function handleSuccess() {
  profiling.finish();

  router.push({ name: RouteNames.OWNERS.INDEX });
}

function handleBack() {
  router.push({ name: RouteNames.OWNERS.INDEX });
}

function openInviteModal() {
  analytics.track(SEGMENT_EVENTS.if_user_invite_modal_opened, {
    source: RouteNames.OWNERS.NEW,
  });
  isInviteModalVisible.value = true;
}

function closeInviteModal() {
  isInviteModalVisible.value = false;
}
</script>

<template>
  <div>
    <ErrorForm v-if="!!errorMessage" :error-message="errorMessage" />
    <div :class="$style['owner-wrapper']">
      <UserNewOwnerForm
        :users="allUsers"
        @on-back="handleBack"
        @on-success="handleSuccess"
        @on-error="handleError"
        @open-invite-modal="openInviteModal"
      />
    </div>

    <UserInviteModal
      :visible="isInviteModalVisible"
      is-business-owners-page
      @close-modal="closeInviteModal"
    />
  </div>
</template>

<style lang="less" module scoped>
.owner-wrapper {
  max-width: 556px;
  margin: 0 auto;
}
</style>
